import { createFileRoute } from "@tanstack/react-router";
import { FeedbackForm1, FeedbackForm2, FeedbackForm3 } from "../../features/feedback/components/FeedbackForms";

const Feedback = () => {
    const search = Route.useSearch();
    const { email, diary_status, name } = search;

    if (!diary_status) {
        // Show a generic feedback form if status is missing
        return <FeedbackForm3 patientName={name || undefined} email={email || undefined} />;
    }

    if (diary_status === "LATE_TO_START" || diary_status === "EMPTY_DIARY") {
        return <FeedbackForm1 patientName={name || undefined} email={email || undefined} />;
    }
    if (diary_status === "LATE_TO_LOG") {
        return <FeedbackForm2 patientName={name || undefined} email={email || undefined} />;
    }
    return <FeedbackForm3 patientName={name || undefined} email={email || undefined} />;
};

export const Route = createFileRoute("/feedback/patient")({
    component: Feedback,
});
